import * as React from "react";
import { useBatteryInfo } from "../../../../Pages/DigitalTwinV3/DigitalTwinContext";
import { DigitalTwinTabContainer } from "../../../../Theme/DigitalTwinStyles";
import { Box, Grid2, Typography } from "@mui/material";
import CustomDailyEventsChart from "./CustomDailyEventsChart";
import CustomEventDetailsTable from "./CustomEventDetailsTable";
import { analyticsCalendarEndDate, getDatePickerDate } from "../../../../Helper/DatePicker/DateConverter";
import ChartCalendar from "../../../DigitalTwinV3/ChartCalendar";
import { usePagesContent } from "../../../../Hooks/usePagesContent";

/**
 * Custom platform Performance tab.
 *
 * Reads customPerformanceEventTypes from org meta and passes them as
 * allowedEventTypes to CustomDailyEventsChart and CustomEventDetailsTable
 * so only configured event types are shown. When no types are configured
 * all event types are shown.
 */
export default function CustomBatteryPerformance({ allowedEventTypes: allowedEventTypesProp } = {}) {
    const { batteryID } = useBatteryInfo();
    const pageContent = usePagesContent();
    const customPerformanceEventTypes = pageContent?.metaInfo?.customPerformanceEventTypes;
    const allowedEventTypes = allowedEventTypesProp
        ?? (customPerformanceEventTypes?.length ? customPerformanceEventTypes : undefined);

    const analyticsCalendarEndDateValue = analyticsCalendarEndDate();
    const [startDate, setStartDate] = React.useState(getDatePickerDate(undefined, -7));
    const [endDate, setEndDate] = React.useState(analyticsCalendarEndDateValue);

    const handleDateChange = ({ startDate: newStartDate, endDate: newEndDate }) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };

    return (
        <DigitalTwinTabContainer>
            <Grid2 container flexDirection="column" gap="4px" padding="4px 12px" mb={1.5}>
                <Typography variant="fw500s20c000000" sx={{ lineHeight: "28px" }}>
                    Daily Events & Event Details
                </Typography>
                <Typography variant="fw400s12c686868" sx={{ lineHeight: "16px" }}>
                    View for up to 7 days
                </Typography>
            </Grid2>

            <Box sx={{ mb: 1.5, display: "flex", justifyContent: "flex-start" }}>
                <ChartCalendar
                    startDate={startDate}
                    endDate={endDate}
                    onDateChange={handleDateChange}
                    disableAfterDate={analyticsCalendarEndDateValue}
                    disablePresets={true}
                    maxRangeDays={7}
                />
            </Box>

            <Grid2 container flexDirection="column" gap={1.5} sx={{ mb: 6 }}>
                <CustomDailyEventsChart
                    batteryID={batteryID}
                    startDate={startDate}
                    endDate={endDate}
                    allowedEventTypes={allowedEventTypes}
                />
                <CustomEventDetailsTable
                    batteryID={batteryID}
                    startDate={startDate}
                    endDate={endDate}
                    allowedEventTypes={allowedEventTypes}
                />
            </Grid2>
        </DigitalTwinTabContainer>
    );
}
